import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.reachedLastDay, action) => {
  switch (action.type) {
    case types.CALENDAR_NO_FUTURE_DATA:
      return true;

    case types.LOG_OUT.SUCCESS:
      return initialState.reachedLastDay;

    default:
      return state;
  }
};
